<template>
  <div class="c-greeting-mission text-primary">
    <div class="container">
      <div class="c-greeting-mission__icon" v-html="helloIcon"></div>
      <div class="c-greeting-mission__title">{{ title }}</div>
      <div class="c-greeting-mission__description">
        {{ description }}
      </div>
      <slot></slot>
      <div class="c-greeting-mission__footer">
        <button
          class="c-greeting-mission__start btn-primary"
          @click="$emit('action')"
        >
          {{ $t("Iniziamo") }}
        </button>
        <router-link class="c-greeting-mission__redirect" to="/dashboard">{{
          $t("Non ora")
        }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import helloIcon from "@/assets/svg/rebuild/hello_icon.svg";

export default {
  name: "GreetingMision",
  props: ["description", "questions", "time", "title"],
  data() {
    return {
      helloIcon
    };
  }
};
</script>

<style lang="scss" scoped>
.c-greeting-mission {
  padding: 50px 30px;
  text-align: center;
}
.c-greeting-mission__title {
  font-size: 30px;
  line-height: 45px;
  font-weight: bold;
}
.c-greeting-mission__description {
  color: #9a9a9a;
  font-size: 20px;
  margin-top: 10px;
}

//footer
.c-greeting-mission__footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
}
.c-greeting-mission__start {
  color: #fff;
  padding: 10px 40px;
  border-radius: 10px;
  text-transform: uppercase;
  margin-bottom: 10px;
  font-weight: bold;
}
.c-greeting-mission__redirect {
  text-decoration: underline;
  font-weight: 500;
}
</style>
